module.exports = __webpack_public_path__ + "static/img/resume-left-right.e77ec0f.png";